import { useCatalog, useSession } from '@tg/app-core';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { useMe } from './lib/data';
import { setTz } from './lib/format';
import { Client } from './pages/Client';
import { Clients } from './pages/Clients';
import { Dashboard } from './pages/Dashboard';
import { ExercisePage } from './pages/Exercise';
import { Exercises } from './pages/Exercises';
import { Groups } from './pages/Groups';
import { ProgramPage } from './pages/Program';
import { Library } from './pages/Library';
import { Login } from './pages/Login';
import { Onboarding } from './pages/Onboarding';
import { Profile } from './pages/Profile';
import { Stub } from './pages/Stub';
import { Constructor } from './constructor/Constructor';
import { WorkoutView } from './pages/WorkoutView';
import { Calendar } from './calendar/Calendar';
import { Shell } from './shell/Shell';
import { ToastHost } from './ui/Toast';

/* Каждое упражнение — своя страница (TPL-2): меняется id в адресе — пересобираем компонент заново,
   чтобы локальное состояние полей не утекало из одного упражнения в другое. */
function ExerciseById() {
  const { id } = useParams();
  /* Форма упражнения берёт значения при первом рендере — ждём базу, иначе после перезагрузки она пустая */
  const cat = useCatalog();
  if (!cat.ready) return null;
  return <ExercisePage key={id} />;
}

function Cabinet() {
  const me = useMe();
  useEffect(() => setTz(me.data?.tz), [me.data?.tz]);
  if (!me.data) return null;
  /* Новый тренер — сначала короткая анкета (REG-3) */
  if (!me.data.first.trim()) return <Onboarding me={me.data} />;
  return (
    <Shell>
      <Routes>
        {/* «/» — лендинг (nginx отдаёт landing/index.html при прямом заходе), кабинет начинается с /dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:id" element={<Client />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/exercises" element={<Exercises />} />
        <Route path="/exercises/new" element={<ExercisePage isNew />} />
        <Route path="/exercises/:id" element={<ExerciseById />} />
        <Route path="/blocks" element={<Library level="block" key="block" />} />
        <Route path="/workouts" element={<Library level="workout" key="workout" />} />
        <Route path="/programs" element={<Library level="program" key="program" />} />
        <Route path="/programs/:id" element={<ProgramPage />} />
        <Route path="/profile" element={<Profile />} />
        {/* Экраны ведущего разработчика — заменит заглушки своими */}
        <Route path="/constructor" element={<Constructor />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/workout" element={<WorkoutView />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Shell>
  );
}

export function App() {
  const s = useSession();
  return (
    <>
      {s && s.role === 'trainer' ? <Cabinet /> : <Login />}
      <ToastHost />
    </>
  );
}
